import { faPaperclip, faDownload, faFilePdf, faFileImage, faFileExcel, faFileWord, faFile, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React,{ useState } from "react";
import { useTranslation } from "react-i18next";
import mainAxios from "../../services/mainAxios";
import DocumentPreview from "../DocumentPreview";
import PrimeTable from "../PrimeTable/PrimeTable";
import { Column } from "primereact/column";
import { purchaseAction } from "./columns/PurchaseAction";
import moment from "moment";
import CellInput from "../global/CellInput";

const PurchasesHistoric = ({  purchaseHistorics , fromPurchaces}) => {
  const [loadingDocument,setLoadingDocument]=useState(false);
  const [filePreview,setFilePreview]=useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const atachmentsRef = React.useRef()
  const containerRef = React.useRef(null)
  const { t } = useTranslation("translations");

  const toggleAttachmentRow = (row) => {
    setExpandedRows((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const isExpanded = list.some((r) => r === row || r?.id === row?.id);
      return isExpanded ? [] : [row];
    });
    requestAnimationFrame(() => {
      const wrapper = containerRef.current?.querySelector(".p-datatable-wrapper");
      if (wrapper) wrapper.scrollTo({ left: 0, behavior: "smooth" });
    });
  };

  const dummyPurchaseHistorics = [
    {
      id: 1,
      workflowAction: { name: "Action 1" },
      workflowStatus: { name: "Status 1" },
      comment: "This is a comment for purchase historic 1.",
      recordDate: new Date(),
      recordUser: "User 1",
      purchaseHistoricAttachments: [
        {
          id: 1,
          name: "attachment1.pdf",
          type: "pdf"
        },
        {
          id: 2,
          name: "attachment2.jpg",
          type: "jpg"
        }
      ]
    },
    {
      id: 2,
      workflowAction: { name: "Action 2" },
      workflowStatus: { name: "Status 2" },
      comment: "This is a comment for purchase historic 2.",
      recordDate: new Date(),
      recordUser: "User 2",
      purchaseHistoricAttachments: [
        {
          id: 3,
          name: "attachment3.xlsx",
          type: "xlsx"
        },
        {
          id: 4,
          name: "attachment4.docx",
          type: "docx"
        }
      ]
    }
  ];
  

  const columns = [
    {
      header: t("logs.action"),
      field: "workflowAction",
      sortable: true,
      style: { minWidth: "120px" },
      body: (row) => {
        if (row?.workflowAction?.name) {
          let purchaseActionProps = purchaseAction(row.workflowAction.name)
          return (
            <div className={`badge badge-${purchaseActionProps.color}`}>
              {purchaseActionProps.name}
            </div>)
        }
        return "";
      },
    },
    {
      header: t("purchases.purchaseStatus"),
      field: "workflowStatus",
      body: (row) => row.workflowStatus?.name ?? "",
      sortable: true,
      style: { minWidth: "150px" }
    },
    {
      header: t("purchases.cisStatus"),
      field: "myPurchaseStatus",
      body: (row) => row.myPurchaseStatus?.name ?? "",
      sortable: true,
      style: { minWidth: "150px" }
    },
    {
      header: t("table.purchaseHistoryDate"),
      field: "recordDate",
      body: (row) => moment(row.recordDate).format("DD/MM/YYYY HH:mm"),
      sortable: true,
      style: { minWidth: "180px" }
    },
    {
      header: t("logs.user"),
      field: "recordUser",
      sortable: true,
      style: { minWidth: "120px" }
    },
    {
      header: t("purchases.comment"),
      field: "comment",
      body: (row) => {
        const commentContent = row?.comment || "";
        if (!commentContent) return "";
        const hasError = commentContent.startsWith("Error");
        return (
          <CellInput
            value={commentContent}
            style={{
              fontSize: "12px",
              padding: hasError ? "2px 6px" : 0,
              borderRadius: "4px",
              backgroundColor: hasError ? "#f8d7da" : "transparent",
              color: hasError ? "#721c24" : "inherit",
            }}
            tooltipStyle={{ maxWidth: "420px" }}
          />
        );
      },
      sortable: true,
      style: { minWidth: "220px", maxWidth: "260px" },
    },
    {
      header: t("purchases.attachments"),
      field: "purchaseHistoricAttachments",
      body: (row) => {
        let purchaseHistoricAttachments = row?.purchaseHistoricAttachments;
        if (purchaseHistoricAttachments?.length > 0) {
          return <div
            className="d-flex align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => toggleAttachmentRow(row)}
          >
            <FontAwesomeIcon icon={faPaperclip} />
            <span className="text-muted ml-1">{purchaseHistoricAttachments.length}</span>
          </div>
        }
        return <span className="text-muted">{t("vat.none")}</span>;
      },
      style: { minWidth: "100px" }
    }
  ];

  const fetchDocument = (e, id, name, type, download = false) => {
    e.preventDefault()
    setLoadingDocument(true)
    mainAxios
      .post("endpoint/v2/getInternalAtachementByte", {
        value: id
      })
      .then((res) => {
        setLoadingDocument(false)
        if (res?.data?.status) {
          if (!download) {
            setFilePreview({
              name,
              type,
              base64: res.data.content[0]
            })
            setTimeout(() => {
              atachmentsRef.current.classList.toggle('open')
            }, 250)
          } else {
            const linkSource = `data:application/pdf;base64,${res.data.content[0]}`;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = name;
            downloadLink.click();
          }
        }
      })
      .catch((_) => {
        setLoadingDocument(false);
      })
  }


  const thumbs = (purchaseHistorics) => {

    const placeholder = (type) => {
      if (type == "pdf") {
        return faFilePdf;
      } else if (type == "jpg" || type == "jpeg" || type == "png") {
        return faFileImage;
      } else if (type == "xlsx") {
        return faFileExcel;
      } else if (type == "docx") {
        return faFileWord;
      } else {
        return faFile;
      }
    }

    if (purchaseHistorics?.purchaseHistoricAttachments) return purchaseHistorics.purchaseHistoricAttachments.map(({ id, name, type }, index) => {

      return (
        <div key={index} className="atachment d-flex flex-column justify-content-center align-items-center">
          <FontAwesomeIcon color="#5c656d" size="3x" icon={placeholder(type)} />
          <div className="atachment-name mx-1 text-center">
            {name}
          </div>
          <div className="d-flex mx-1 mt-3">
            <button
              className="attachment__actions--button bg-primary"
              onClick={(e) => { if (!loadingDocument) fetchDocument(e, id, name, type) }}
            >
              <FontAwesomeIcon icon={faEye} />
            </button>
            <button
              className="attachment__actions--button bg-info"
              onClick={(e) => { if (!loadingDocument) fetchDocument(e, id, name, type, true) }}>
              <FontAwesomeIcon icon={faDownload} />
            </button>
          </div>
        </div>
      )
    })
    return <></>
  }

  const closePreview = () => {
    setTimeout(() => {
      setFilePreview(null)
    }, 150);
    atachmentsRef.current.classList.toggle('open')
  }

  const rowExpansionTemplate = (data) => {
    return (
      <div>
        <div className="attachment__container d-flex flex-wrap">{thumbs(data)}</div>
        <div className="pdf-container" ref={atachmentsRef}>
          {filePreview &&
            <div className="pdf-viewer">
              <div className="pdf-overlay" onClick={closePreview} />
              <div className="pdf-content">
                <DocumentPreview filePreview={{ name: filePreview.name, base64: filePreview.base64, extension: filePreview.type }} />
              </div>
            </div>
          }
        </div>
      </div>
    );
  };

  return (
    <div ref={containerRef} className={fromPurchaces ? "" : "border-0 card-accordion p-0"}>
      <PrimeTable
        columns={columns}
        value={purchaseHistorics}
        simpleTable={true}
        showSelectColumns={false}
        clearFilters={false}
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        rowExpansionTemplate={rowExpansionTemplate}
        searchableKeys={["recordDate", "recordUser", "workflowStatus", "myPurchaseStatus.name", "comment"]}
        showGlobalSearch={true}
        defaultSortCriteria={{ field: "recordDate", direction: "DESC" }}
      >
        <Column
          expander={(row) => row?.purchaseHistoricAttachments?.length > 0}
          style={{ minWidth: 40, maxWidth: 60 }}
          header=""
          field="expansion"
        />
      </PrimeTable>
    </div>
  );
};

export default PurchasesHistoric;
